<template>
    <svg width="13" height="7" viewBox="0 0 13 7" xmlns="http://www.w3.org/2000/svg"><path d="M0 1.52588e-05H12.7279L6.36396 6.36398L0 1.52588e-05Z" fill="inherit"/></svg>
</template>